import { I as InputText, d as defineCustomElement$1 } from './input-text.js';
var SkpInputText = InputText;
var defineCustomElement = defineCustomElement$1;
export { SkpInputText, defineCustomElement };